(function () {
  'use strict';

  var toggle = document.querySelector('[data-nav-toggle]');
  var drawer = document.querySelector('[data-nav-drawer]');
  if (toggle && drawer) {
    toggle.addEventListener('click', function () {
      var open = drawer.classList.toggle('is-open');
      toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
  }

  document.querySelectorAll('[data-gallery]').forEach(function (gallery) {
    var main = gallery.querySelector('[data-gallery-main] img');
    if (!main) return;
    gallery.querySelectorAll('[data-gallery-thumb]').forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        var full = thumb.getAttribute('data-full');
        if (full) main.setAttribute('src', full);
        gallery.querySelectorAll('[data-gallery-thumb]').forEach(function (t) {
          t.setAttribute('aria-current', t === thumb ? 'true' : 'false');
        });
      });
    });
  });

  document.querySelectorAll('[data-variant-select]').forEach(function (select) {
    var form = select.closest('form');
    if (!form) return;
    select.addEventListener('change', function () {
      var input = form.querySelector('[name="id"]');
      if (input) input.value = select.value;
      var opt = select.options[select.selectedIndex];
      var btn = form.querySelector('[data-add-button]');
      if (btn && opt) {
        var avail = opt.getAttribute('data-available') === 'true';
        btn.disabled = !avail;
        btn.textContent = avail ? btn.getAttribute('data-label-default') : btn.getAttribute('data-label-soldout');
      }
      var priceEl = document.querySelector('[data-variant-price]');
      if (priceEl && opt && opt.getAttribute('data-price')) {
        priceEl.textContent = opt.getAttribute('data-price');
      }
    });
  });
})();
